/**
 * How to reach the Global IT Helpdesk directly, outside the portal.
 *
 * Shared by the emergency page and by every place the portal has to say "we
 * can't do this for you here" — most visibly when Ivanti has no record of the
 * signed-in person yet. Plain constants in one file, for the reasons given in
 * `features/emergency/emergency-contact.ts`.
 */

/**
 * Opens a Teams chat with the Global IT Helpdesk account.
 *
 * The `l/chat` deep link form needs no integration, no bot registration and no
 * API — it is a URL Teams understands. It works from the browser and from the
 * desktop client.
 */
export const HELPDESK_TEAMS_URL =
  "https://teams.microsoft.com/l/chat/0/0?users=Global-IT-Helpdesk@norican.com";

/** The Global IT Helpdesk mailbox. */
export const HELPDESK_EMAIL = "Global-IT-Helpdesk@norican.com";

/** `mailto:` form of {@link HELPDESK_EMAIL}. */
export const HELPDESK_EMAIL_HREF = `mailto:${HELPDESK_EMAIL}`;
